module.exports = __webpack_public_path__ + "img/home-banner1.3fb86506.jpg";